import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import './index.css';

/**
 * Application Entry Point
 * OutdoorGuides Platform - Bootstrap MVP
 *
 * Provider hierarchy:
 * 1. AuthProvider - Manages authentication state (user, tokens)
 */

// Configure axios to automatically include Authorization header
axios.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    // Include credentials (cookies) with requests
    config.withCredentials = true;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
        <App />
    </AuthProvider>
  </React.StrictMode>
);
